import React, { useEffect, useState } from "react";

/**
 * Thin cyan stripe at the very top of the viewport that fills as the visitor
 * scrolls the page. Renders on every route. Honours prefers-reduced-motion.
 */
export const ScrollProgress = () => {
    const [pct, setPct] = useState(0);

    useEffect(() => {
        const calc = () => {
            const doc = document.documentElement;
            const max = doc.scrollHeight - doc.clientHeight;
            const value = max > 0 ? (doc.scrollTop / max) * 100 : 0;
            setPct(Math.min(100, Math.max(0, value)));
        };
        calc();
        window.addEventListener("scroll", calc, { passive: true });
        window.addEventListener("resize", calc);
        return () => {
            window.removeEventListener("scroll", calc);
            window.removeEventListener("resize", calc);
        };
    }, []);

    return (
        <div
            className="scroll-progress"
            role="progressbar"
            aria-valuenow={Math.round(pct)}
            aria-valuemin={0}
            aria-valuemax={100}
            data-testid="scroll-progress"
        >
            <div
                className="scroll-progress-fill"
                style={{ transform: `scaleX(${pct / 100})` }}
            />
        </div>
    );
};

export default ScrollProgress;
